import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { groupsApi } from '../lib/domain';
import { ApiError } from '../lib/api';

export function InviteRedeemPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const [status, setStatus] = useState<'idle' | 'busy' | 'done' | 'error'>('idle');
  const [message, setMessage] = useState('');

  async function redeem() {
    setStatus('busy');
    try {
      const res = await groupsApi.redeemInvitation(token);
      setStatus('done');
      setTimeout(() => navigate(`/groups/${res.group.id}`), 800);
    } catch (err) {
      setStatus('error');
      setMessage(err instanceof ApiError ? err.message : 'Einladung konnte nicht eingelöst werden.');
    }
  }

  return (
    <div className="card stack">
      <h1>Gruppeneinladung</h1>
      {status === 'idle' && (
        <>
          <p>Du wurdest zu einer Gruppe eingeladen.</p>
          <button className="primary" onClick={redeem}>
            Einladung annehmen
          </button>
        </>
      )}
      {status === 'busy' && <p>Wird eingelöst…</p>}
      {status === 'done' && <p>Beigetreten! Du wirst weitergeleitet…</p>}
      {status === 'error' && <p className="error-text">{message}</p>}
    </div>
  );
}
